import axiosInstance from "../axios";
import axios from "axios";
const { REACT_APP_LOGIN_API_BASEURL } =
  process.env;

export const countryService = {
  getCountries: () => {
    return axios.get(`https://countriesnow.space/api/v0.1/countries/states`);
  }
};

export const cityService = {
  getCities: (country,states) => {
     return axios.post(`https://countriesnow.space/api/v0.1/countries/state/cities`, {
      country: country,
      state: states
    });
  }
};